<template>
  <div class="audit-label">
    <div class="audit-label-info">
      <span class="audit-label-info-key">状态:</span>
      <span class="audit-label-info-value">已拒绝</span>
    </div>
    <div class="audit-label-info">
      <span class="audit-label-info-key"></span>
      <span class="audit-label-info-value">
        <span style="color: #999999;">您提交的认证信息审核未通过，请仔细查看提交页填写说明</span>
        <span style="color: #999999;"> | </span>
        <span v-if='showBtn' class="link"><router-link :to="{name: 'companyAdd'}">修改并申请</router-link></span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "reject",
  computed: {
    showBtn () {
      const { arcUserInfo } = this.$store.state
      if (![1, 20, 100].includes(arcUserInfo.level)) { // 如果是通过/拒绝 但是不是开发者
        return false
      }
      return true
    },
  }
}
</script>

<style scoped lang="scss">
.audit-label {
  .audit-label-info {
    padding: 16px 34px 0;
    .audit-label-info-key {
      font-size: 14px;
      color: #505050;
      display: inline-block;
      width: 180px;
    }

    .audit-label-info-value {
      font-size: 14px;
      color: #505050;

      .link {
        background: #F7FBFF;
        border-radius: 4px;
        font-size: 12px;
        color: #00A1D6;
        padding: 6px 9px;
      }
    }
  }
}
</style>
